module.exports = __webpack_public_path__ + "static/bottle-plant-5c3196352dbf5b94439bfb3907b7b5b8.jpg";